/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-mat-option .mat-option-text{overflow:auto;text-overflow:unset}  .nav-items .mat-optgroup-label{color:#3f51b5;background-color:#eee!important}  .assignment-items .mat-optgroup-label{color:#3f51b5;background-color:#eee!important}  .supplier-items .mat-optgroup-label{color:#3f51b5;background-color:#eee!important}  .resource-items .mat-optgroup-label{color:#3f51b5;background-color:#eee!important}\n/*# sourceMappingURL=dashboard-search.component.css.map*/"];
export { styles as styles };
